import React from "react";
import chroma from "chroma-js";

export const colors = [
    '#003262',
    '#3f8bac',
    '#7b892b',
    '#b1bf53',
    '#ee2162',
    '#d66821',
    '#f0ac15',
    '#00b0da'
];

//TODO not working yet
const accessibleBackgrounds = {};
colors.forEach((color, i) => {
    const targetContrast = 3.3;
    let c = chroma(color);
    c = c.darken(0.3);//make all a little darker
    let safety = 100;
    while (chroma.contrast('white', c) < targetContrast) {
        //console.log(color, c.hex(), chroma.contrast('white', c));
        if (--safety === 0) break;
        c = c.darken(0.1);
    }
    accessibleBackgrounds[color] = c;
});

export const darkenedBg = (color) => {
    return accessibleBackgrounds[color];
    // let ans = chroma(color);
    // return ans.darken(0.71);
};

export const profileChoices = {
    'ug': 'UC Berkeley undergraduate student',
    'grad': 'UC Berkeley graduate student',
    'faculty': 'UC Berkeley faculty',
    'staff': 'UC Berkeley staff',
    'alum': 'UC Berkeley alumnus',
    'retiree': 'UC Berkeley retiree/emeriti',
    'community': 'Community member',
    'other': 'Other or Prefer Not to Answer',
};

const jpegFileIds = [
    'AC_3',
    'CD_10',
    'CD_5',
    'CD_7',
    'CD_6',
    'CD_8',
    'CD_3',
    'CD_2',
    'GA_4',
    'GA_6',
    'GA_5',
    'GA_3',
    'CD_4',
    'CP_2',
    'EWC_3',
    'EWC_4',
    'EWC_2',
];

const imageTitles = [
  {
    "FileName": "CP_2.jpg",
    "Title": "Map of Planning Area",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "This map shows the geographic extents of the Campus Master Plan and Long Range Development Plan, which include the Campus Park, Smyth Fernwald, Clark Kerr, the Hill Campus, and other UC Berkeley owned sites in the area."
  },
  {
    "FileName": "AC_2.png",
    "Title": "Summary of All Existing Indoor Campus Space",
    "Needed?": "N",
    "Other Notes": "Middle of graph already explains what it is.",
    "Alt Text": "This pie chart shows the distribution of overall space types within the existing campus: Instructional 5%; Research 16%; Office and conference 33%; Study and Stack 10%, Campus Life 10%, and Housing 26%."
  },
  {
    "FileName": "AC_3.jpg",
    "Title": "Classroom Utilization",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "This scatterplot maps weekly room hours against occupacy (percent of seats filled). Many of the larger classrooms on campus (300 seats or more) are frequently used by classes that fill up 60% or more of the seats.  Smaller classrooms (up to 25 seats) vary, with many being used more frequently than other size rooms with seat fills that range between 50-80%.  Classrooms between 51-100 seats tend to be used less frequently, and sometimes with lower seat fills."
  },
  {
    "FileName": "AC_4.png",
    "Title": "Desired Additional Academic Life Spaces",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This graph shows results from the 2019 LRDP and Campus Master Plan Survey.  Desired additional academic life spaces include: Individual study 67%, Collaboration and group study 61%, Improved classrooms 60%, Research 31%, Improved teaching labs 21%, Maker spaces 20%, and Other 7%.  (Survey takers could check more than 1 answer.)"
  },
  {
    "FileName": "AC_5.png",
    "Title": "Academic Life Space Needs",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This infographic compares existing academic space categories to current need and future need, based on the Campus Master Plan and LRDP space analysis.  Office and research space are the largest current uses, and both categories have some current needs that are not being met with existing space and projected need for more space in the future.  Study space is the category with the greatest relative deficit today and in the future."
  },
  {
    "FileName": "CD_2.jpg",
    "Title": "Historic Campus Plan by John Galen Howard (1914)",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Historic map from 1914 by John Galen Howard that shows how the campus was organized.  Memorial Glade and the central green axis was designed to align with views of the Golden Gate."
  },
  {
    "FileName": "CD_3.jpg",
    "Title": "Removed",
    "Needed?": "",
    "Other Notes": "",
    "Alt Text": ""
  },
  {
    "FileName": "CD_4.jpg",
    "Title": "Campus Building Uses Today",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Map of current building uses on campus.  The Campus Park is predominantly academic-related (study space, labs, offices, and classrooms) with a few student life spaces.  Housing is located around the edges outside the Campus Park.  In the southeast, Clark Kerr Campus is primarily housing, with student life, recreation, and athletics uses."
  },
  {
    "FileName": "CD_5.jpg",
    "Title": "Campus Landscape Structure: Major Landscape Features",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Map showing how the landscapes on campus act as a defining structure, shape different zones of campus, and provide spaces of open space enjoyment.  The largest landscapes are the north and south branches of Strawberry Creek that run through the campus, along with the central glade that runs east and west."
  },
  {
    "FileName": "CD_6.jpg",
    "Title": "Campus Landscape Structure: Outdoor Athletics and Recreation Fields",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Outdoor atheletics and recreation fields now are added to the map.  These uses like Edwards Stadium and Memorial Stadium are located primarily along the southern and eastern edges of the Campus Park, with a few uses at Clark Kerr Campus"
  },
  {
    "FileName": "CD_7.jpg",
    "Title": "Campus Landscape Structure: Plazas and Courtyards",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Plazas and courtyards are now added to the map. These smaller outdoor spaces provide moments for outdoor gathering throughout campus. Some of the most significant are Upper Sproul Plaza, Lower Sproul Plaza, and the Campanile Esplanade."
  },
  {
    "FileName": "CD_8.jpg",
    "Title": "Campus Landscape Structure: Gateways",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Gateways are now added to the map.  The main gateways include Sather Gate and Sproul Plaza on the southern edge and Springer Gateway at the West Crescent."
  },
  {
    "FileName": "CD_9.jpg",
    "Title": "Pervious and Impervious Surfaces on Campus Today",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Total 59% of campus is impervious surfaces, which includes buildings and paths.  The remaining 41% is pervious land, which includes lawns, planted areas, and other landscapes."
  },
  {
    "FileName": "CD_10.jpg",
    "Title": "Pervious and Impervious Surfaces on Campus Today",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "This map shows where pervious and impervious lands are located on campus.  The central glade, Strawberry Creek, North Field, recreation and athletics fields, and a network of smaller green spaces make up the pervious areas.  The southern and eastern edges of the Campus Park tend to have higher rates of impervious land."
  },
  {
    "FileName": "CP_3.png",
    "Title": "Comparing the Long Range Development Plan and Campus Master Plan",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Table comparing the Long Range Development Plan with the Campus Master Plan.  Differences: The Long Range Development Plan is a program-level plan (land use plan) that guides the long-term physical development of the campus; it is required by law and requires an Environmental Impact Report (EIR); can be long-term; requires Regents approval; geography: covers all of the university’s space within the City of Berkeley, plus the entire Hill Campus.  The Campus Master Plan is an aspirational ten-year plan with specific projects to address priorities, such as housing, sustainability, academic space; not required by law; does not require an EIR; living document: can be short or long term; Chancellor’s approval required; geography: includes same area as the Long Range Development Plan but may also consider strategic uses for campus sites outside of that boundary, such as University Village or Richmond Field Station.  Similarities between the Long Range Development Plan and the Campus Master Plan: Both documents are aligned with the Strategic Plan, employ an integrated, systems-level approach, build campus concensus around a shared vision, are strategic and prioritize investments."
  },
  {
    "FileName": "EWC_5.png",
    "Title": "Natural Hazard Risks",
    "Needed?": "Y",
    "Other Notes": "Title pending replacement image selection",
    "Alt Text": "This image includes a series of icons that show natural hazards that the campus faces now and in the future including: warmer weather, less rainfall, fire hazards, extreme storms, and earthquakes."
  },
  {
    "FileName": "EWC_6.png",
    "Title": "Campus energy infrastructure networks deliver cooling/heating and power",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Flowchart showing how campus energy infrastructure networks get cooling/heating and power to buildings"
  },
  {
    "FileName": "EWC_7.png",
    "Title": "Existing Campus Water Use",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "Graph showing existing water use on campus, which totals 594.4 million gallons.  Water use is composed of: domestic uses by housing - 25%; labs - 25%; domestic uses by all other buildings - 24%; cooling and heating - 17%; irrigation - 8%; and other - 1%."
  },
  {
    "FileName": "GA_2.png",
    "Title": "How employees and students get to campus",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "Graph showing how employees, students, and all UC Berkeley affiliates travel to campus today.  Employees are the most likely to drive alone (44%), while 91% of students walk, bike, or take transit (62% walk, 12% bike, and 17% take transit)."
  },
  {
    "FileName": "GA_3.jpg",
    "Title": "AC Transit Ridership",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "Map showing the number of boardings and alightings by AC Transit stop around the Campus Park.  The stops with the greatest number of boardinds/alightings include the areas around Sproul Plaza and College Ave.  Other areas with high numbers include the West Crescent, northeastern campus along Hearst Avenue, and other areas in the Southside."
  },
  {
    "FileName": "GA_4.jpg",
    "Title": "Pedestrian Volumes",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This map shows pedestrian volumes across campus.  Sproul Plaza and Sather Gate have the highest concentration, with more than 40,000 pedestrians traveling north/south through it."
  },
  {
    "FileName": "GA_5.jpg",
    "Title": "Bicycle Volumes",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This map shows bicycle volumes across campus.  The highest counts are recorded on University Drive near the West Circle (1,100 or more bicyclists between 7 am and 7 pm)."
  },
  {
    "FileName": "GA_6.jpg",
    "Title": "Vehicle Traffic Volumes",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This map shows motor vehicle volumes, which ranged up to 1,871 or more between 7 am and 7 pm when counts were recorded.  The highest counts were recorded around the West Crescent, University Drive near the West Circle, Frank Schlessinger Way (just north of the Hellman Tennis Center), and University Drive just south of Stanley Hall."
  },
  {
    "FileName": "LC_2.gif",
    "Title": "Academic Life on Campus on a Typical Tuesday",
    "Needed?": "Y",
    "Other Notes": "",
    "Alt Text": "This animation shows how academic patterns shift across campus on a Tuesday."
  },
  {
    "FileName": "LC_3.png",
    "Title": "Desired Additional Campus Life Spaces",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This graph shows results from the 2019 LRDP and Campus Master Plan Survey. Desired additional campus life spaces include: Gathering/hangout - 59%; Recreation - 57%; Contemplative/meditation - 42%; Dining facilities - 33%; Student organization - 33%; and Other - 10%."
  },
  {
    "FileName": "LC_4.png",
    "Title": "Campus Life Space Needs",
    "Needed?": "N",
    "Other Notes": "(Not needed unless images is exported without title)",
    "Alt Text": "This infographic compares existing campus life space categories to current need and future need, based on the Campus Master Plan and LRDP space analysis.  The greatest needs are in recreation/wellness and social space; both of these categories are significantly undersized to meet existing need and this gap is projected to increase in the future.  Dining is a little undersized relative to current and future need, while assembly and exhibition is already large enough to meet current and projected future need."
  }
];

const gifFileIds = [
    'LC_2'
];
const getExt = (key) => {
    if (gifFileIds.indexOf(key) >= 0) {
        return 'gif';
    } else if (jpegFileIds.indexOf(key) >= 0) {
        return 'jpg';
    }
    return 'png';
};
export const getSectionImage = (group, key) => {
    return `img/${group}/${key}.${getExt(key)}`;
};
export const getAltText = (key) => {

    if (key) {
        const imageTitle = imageTitles.filter(image => image.FileName.split('.')[0] === key);
        if (imageTitle.length){
          // console.log(imageTitle)
          return {
              title: (imageTitle[0]["Needed?"] === 'Y' ? imageTitle[0].Title : ''),
              alt: imageTitle[0]["Alt Text"] || imageTitle[0].Title,
          }
        }
    }
    return {
        title: "",
        alt: ""
    }
};
export const getSectionColor = (group) => {
    return sectionsByKey[group].color;
};
export const getInfoClass = (activeKey, key) => {
    let ans = 'image-info';
    if (key !== activeKey) {
        ans += ' lowlight';
    }
    return ans;
};
export const getImageInfoStyle = (color, activeKey, key) => {
    return {backgroundColor: darkenedBg(color)};
};

export const sections = [
    {
        key: 'CP',
        title: 'Campus Planning 101',
        color: colors[1],
        subtitle: 'What does it mean to have a campus plan?'
    },
    {
        key: 'CD',
        title: 'Design and Character',
        color: colors[2],
        subtitle: 'What is the purpose of organizing the campus?'
    },
    {
        key: 'LC',
        title: 'Life on Campus',
        color: colors[3],
        subtitle: 'How does the campus make you feel at home?'
    },
    {
        key: 'AC',
        title: 'Instruction and Research',
        color: colors[4],
        subtitle: 'How does the physical environment support the university’s core mission?'
    },
    {
        key: 'GA',
        title: 'Getting Around',
        color: colors[5],
        subtitle: 'How is the Berkeley community getting to and around campus?'
    },
    {
        key: 'EWC',
        title: 'Sustainability and Climate',
        color: colors[6],
        subtitle: 'What keeps the campus running (besides people)?'
    },
    {
        key: 'CPR',
        title: 'Your Campus Priorities',
        color: colors[7],
        subtitle: 'What are your top priorities for UC Berkeley’s campus?'
    },
];
export const sectionsByKey = {};
sections.forEach((section, i) => {
    sectionsByKey[section.key] = section;
});
